import React, { useState } from "react";
import { Copy, Check, Gift, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

/**
 * HomeReferralWidget — v3.99d.364
 *
 * Compact "share your link and earn $20" widget mounted inside the
 * homepage hero for authenticated customers only. Signed-out visitors
 * see SignupBonusPromoBanner instead, so the two never collide.
 */
export default function HomeReferralWidget() {
  const { user } = useAuth();
  const [copied, setCopied] = useState(false);

  if (!user || user.role !== "customer" || !user.referral_code) return null;

  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const shareUrl = `${origin}/?ref=${encodeURIComponent(user.referral_code)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
      toast.success("Referral link copied");
    } catch {
      toast.error("Copy failed");
    }
  };

  return (
    <div
      className="mt-8 inline-flex items-center gap-3 border px-3 py-2 sm:px-4 sm:py-2.5 flex-wrap max-w-full"
      style={{ borderColor: "var(--gold)",
                background: "rgba(212,175,55,0.08)",
                borderRadius: 2 }}
      data-testid="home-referral-widget">
      <Gift className="w-4 h-4 flex-shrink-0"
             style={{ color: "var(--gold)" }}/>
      <div className="min-w-0">
        <div className="text-[9px] font-mono uppercase tracking-[0.22em]"
             style={{ color: "var(--gold)" }}>
          Refer a collector · Earn $20
        </div>
        <div className="text-[12px] sm:text-[13px] font-mono truncate max-w-[220px] sm:max-w-[300px]"
             style={{ color: "var(--text)" }}
             data-testid="home-referral-widget-url">
          {shareUrl}
        </div>
      </div>
      <button
        type="button"
        onClick={copy}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 text-[10px] font-mono uppercase tracking-wider transition flex-shrink-0"
        style={{ background: copied ? "var(--gold)" : "transparent",
                  color: copied ? "var(--bg)" : "var(--gold)",
                  border: "1px solid var(--gold)",
                  borderRadius: 2 }}
        data-testid="home-referral-widget-copy">
        {copied ? <Check className="w-3 h-3"/> : <Copy className="w-3 h-3"/>}
        {copied ? "Copied" : "Copy"}
      </button>
      <Link to="/bonus"
             className="inline-flex items-center gap-1 text-[10px] font-mono uppercase tracking-wider hover:opacity-80 flex-shrink-0"
             style={{ color: "var(--gold)" }}
             data-testid="home-referral-widget-details">
        Rules
        <ArrowRight className="w-3 h-3"/>
      </Link>
    </div>
  );
}
